import { LoadingChildren } from '../../components/loadingChildren';

interface ProfileDescriptionProps {
  description: string;
  isLoading: boolean;
}

/**
 * Profile description section.
 */
export const ProfileDescription = ({ description, isLoading }: ProfileDescriptionProps) => {
  return (
    <div className="mt-1 flex items-center justify-center">
      <LoadingChildren
        expectedChars={12}
        loadingClassName="mt-1 text-md text-center m-auto"
        loading={isLoading}
      >
        <p className="mt-1 text-md text-center sm:w-[50%] m-auto">{description}</p>
      </LoadingChildren>
    </div>
  );
};
